import { FbwA380xChecklistMarketingSeo } from "../../../content/templateMarketing/fbw-a380x-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fbwA380xImage from "../../images/templates/fbw-a380x.png";

export const fbwA380xTemplate: AircraftAddonTemplate = {
  type: "aircraft",
  title: "FlyByWire A380X",
  id: "fbw-a380x",
  platforms: ["msfs"],
  image: fbwA380xImage,
  infoMarketingBlurb: FbwA380xChecklistMarketingSeo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        { header: "Safety Check" },
        { item: "Parking Brake", setting: "Set" },
        { item: "Speed Brakes", setting: "Retracted" },
        { item: "Flaps", setting: "Up" },
        { item: "Engine Master Switches", setting: "Off" },
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Landing Gear Lever", setting: "Down" },
        { item: "Engine Mode Selector", setting: "Norm" },
        { item: "Wipers", setting: "Off" },
        { header: "Power Up" },
        { item: "Batteries", setting: "On" },
        { item: "External Power", setting: "As Req" },
        { item: "Nav Lights", setting: "On" },
        { item: "Fire Test", setting: "Perform" },
        { item: "APU", setting: "Start" },
        { header: "Overhead Panel" },
        { item: "Oxygen Crew Supply", setting: "On" },
        { item: "ADIRS", setting: "Nav" },
        { item: "Strobe Lights", setting: "Auto" },
        { item: "Passenger Signs", setting: "On / Auto" },
        { item: "Emergency Exit Lights", setting: "Armed" },
        { item: "APU Bleed", setting: "On" },
        { item: "Fuel Pumps", setting: "On" },
        { item: "Overhead Panel", setting: "No White Lights" },
        { header: "Glare Shield & Pedestal" },
        { item: "Altimeter", setting: "Set" },
        { item: "Flight Director", setting: "On" },
        { item: "Transponder", setting: "Set & Auto" },
      ],
    },
    {
      title: "Before Start",
      roles: ["beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        { item: "IRS", setting: "Aligned" },
        { item: "Windows", setting: "Closed" },
        { item: "Cockpit Door", setting: "Locked" },
        { item: "APU", setting: "On" },
        { item: "APU Bleed", setting: "On" },
        { item: "External Power", setting: "Off & Disconnected" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Beacon", setting: "On" },
      ],
    },
    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Engine Mode Selector", setting: "Ign / Start" },
        { item: "Engine Masters 1 & 2", setting: "On" },
        { item: "Engine Masters 3 & 4", setting: "On" },
        { item: "Engine Mode Selector", setting: "Norm" },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart", "beforeTaxi"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Engine Mode Selector", setting: "Norm" },
        { item: "APU Bleed", setting: "Off" },
        { item: "APU Master", setting: "Off" },
        { item: "Engine Anti-Ice", setting: "As Req" },
        { item: "Flaps", setting: "Set for Takeoff" },
        { item: "Speed Brakes", setting: "Armed" },
        { item: "Rudder Trim", setting: "Zero" },
        { item: "Pitch Trim", setting: "____ Set" },
        { item: "ECAM Status", setting: "Check" },
        { item: "Flight Controls", setting: "Check" },
      ],
    },
    {
      title: "Taxi",
      roles: ["taxi"],
      content: [
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Rwy Turn Off Lights", setting: "As Req" },
        { item: "Parking Brake", setting: "Release" },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        { item: "Packs", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "Engine Mode Selector", setting: "As Req" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Transponder", setting: "Auto" },
        { item: "TCAS", setting: "TA/RA" },
        { item: "EFIS ND Mode & Range", setting: "Set" },
        { item: "EFIS Traffic", setting: "On" },
        { item: "EFIS Terrain", setting: "On" },
        { item: "Autobrake", setting: "RTO" },
        { item: "Speed Brakes", setting: "Armed" },
        { item: "Flaps", setting: "Set for Takeoff" },
        { item: "T.O. Config Check", setting: "No Blue" },
        { header: "Cleared for Takeoff" },
        { item: "Strobe Lights", setting: "On" },
        { item: "Landing Lights", setting: "On" },
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "Rwy Turn Off Lights", setting: "On" },
      ],
    },
    "page-break",
    {
      title: "After Takeoff",
      roles: ["climbOut"],
      content: [
        { item: "Landing Gear", setting: "Up" },
        { item: "Flaps", setting: "Retracted" },
        { item: "Speed Brakes", setting: "Disarm" },
        { item: "Engine Mode Selector", setting: "As Req" },
        { item: "Nose Lights", setting: "Off" },
        { item: "Rwy Turn Off Lights", setting: "Off" },
        { item: "Packs", setting: "On" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "TCAS", setting: "TA/RA" },
        { header: "Passing Transition Altitude" },
        { item: "Altimeters", setting: "Set STD" },
        { header: "Passing 10,000 ft" },
        { item: "Landing Lights", setting: "Off" },
        { item: "EFIS Terrain", setting: "Off" },
        { item: "Passenger Signs", setting: "As Req" },
      ],
    },
    {
      title: "Descent Preparation",
      roles: ["beforeDescent"],
      content: [
        { item: "Autobrake", setting: "Set" },
        { item: "FCU Altitude", setting: "Set" },
        { item: "Fuel Quantity", setting: "Check" },
        { item: "Passenger Signs", setting: "As Req" },
      ],
    },
    {
      title: "Descent",
      roles: ["descent"],
      content: [
        { item: "Passenger Signs", setting: "On" },
        { item: "Engine Mode Selector", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { header: "Passing Transition Level" },
        { item: "Altimeters", setting: "Set Local" },
        { header: "Passing 10,000 ft" },
        { item: "Landing Lights", setting: "On" },
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "Rwy Turn Off Lights", setting: "On" },
        { item: "Passenger Signs", setting: "On / On" },
        { item: "EFIS Terrain", setting: "As Req" },
      ],
    },
    {
      title: "Approach",
      roles: ["approach"],
      content: [
        { item: "Altimeter", setting: "____ Set (Both)" },
        { item: "Seat Belts", setting: "On" },
        { item: "Minimums", setting: "____ Set" },
        { item: "Autobrake", setting: "Verify Set" },
      ],
    },
    {
      title: "Landing",
      roles: ["landing"],
      content: [
        { item: "Landing Gear", setting: "Down" },
        { item: "Flaps", setting: "Full" },
        { item: "Ground Spoilers", setting: "Armed" },
        { item: "ECAM Memo", setting: "Landing No Blue" },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        { item: "Strobe Lights", setting: "Auto" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Rwy Turn Off Lights", setting: "As Req" },
        { item: "Anti-Ice", setting: "As Req" },
        { item: "APU", setting: "Start" },
        { item: "EFIS Terrain", setting: "Off" },
        { item: "EFIS Traffic", setting: "Off" },
        { item: "Speed Brakes", setting: "Retracted" },
        { item: "Flaps", setting: "Retracted" },
        { item: "Transponder", setting: "Auto" },
        { item: "TCAS", setting: "Stby" },
      ],
    },
    {
      title: "Parking / Shutdown",
      roles: ["parking", "shutdown"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Nose Lights", setting: "Off" },
        { item: "Rwy Turn Off Lights", setting: "Off" },
        { item: "Anti-Ice", setting: "Off" },
        { item: "APU Bleed", setting: "On" },
        { item: "Engine Mode Selector", setting: "Norm" },
        { item: "Engine Master Switches", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "Beacon", setting: "Off" },
        { item: "Fuel Pumps", setting: "Off" },
        { item: "Transponder", setting: "Stby" },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        { item: "Parking Brake", setting: "On" },
        { item: "Oxygen Crew Supply", setting: "Off" },
        { item: "ADIRS", setting: "Off" },
        { item: "Exterior Lights", setting: "Off" },
        { item: "APU Bleed", setting: "Off" },
        { item: "APU Master", setting: "Off" },
        { item: "Emergency Exit Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "External Power", setting: "As Req" },
        { item: "Batteries", setting: "Off" },
      ],
    },
  ],
};
